var map = {
	"./af/Activity.json": 96666,
	"./af/Client.json": 77251,
	"./af/Contact.json": 84371,
	"./af/EmailQuote.json": 14485,
	"./af/ExchangeRate.json": 69160,
	"./af/LineItem.json": 29468,
	"./af/OrgTaxRate.json": 16917,
	"./af/Person.json": 7213,
	"./af/PriceList.json": 6784,
	"./af/Quote.json": 6350,
	"./af/ServiceItem.json": 34003,
	"./af/Supplier.json": 89172,
	"./af/common.json": 48312,
	"./en/Activity.json": 86262,
	"./en/Client.json": 47373,
	"./en/Contact.json": 49936,
	"./en/EmailQuote.json": 15044,
	"./en/ExchangeRate.json": 27828,
	"./en/LineItem.json": 77008,
	"./en/OrgTaxRate.json": 69304,
	"./en/Person.json": 1476,
	"./en/PriceList.json": 59526,
	"./en/Quote.json": 23725,
	"./en/ServiceItem.json": 79437,
	"./en/Supplier.json": 1636,
	"./en/common.json": 80401
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30017;